import { DELETE } from 'react-admin'


const DELETE_INSTALATION = 'DELETE_INSTALATION';
export const deleteInstalation = (record, resource, basePath) => ({
    type: DELETE_INSTALATION,
    payload: { id: record.id, previousData: record },
    meta: {
        resource: resource,
        fetch: DELETE,
        onSuccess: {
            notification: {
                body: 'Registro eliminado',
                level: 'info',
            },
            refresh: true,
            basePath
        },
        onFailure: {
            notification: {
                body: 'Error al intentar eliminar el registro',
                level: 'warning',
            }
        }
    },
});
